export default __webpack_public_path__ + "static/media/logo.d8ce161c.gif";